import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { QuoteIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const active = testimonials[index];
  const go = (direction: 1 | -1) => {
    setIndex(current => (current + direction + testimonials.length) % testimonials.length);
  };
  return <section className="border-b border-carbon-800 bg-carbon-950 py-20 sm:py-24" id="testimonios" data-id="element-134" data-mp="36wwetbjuhx4z">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-135" data-mp="321z8wdhv43wb">
        <div className="text-center" data-id="element-136" data-mp="2x1uquj1b313z">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-safety" data-id="element-137" data-mp="2x2w2opq5brmr">
            Técnicos que ya la usan
          </p>
          <h2 className="mt-4 text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl" data-id="element-138" data-mp="v96n88kr2bno">
            Resultados en el mesón, no en la teoría
          </h2>
        </div>

        <div className="mt-12 rounded-2xl border border-carbon-700 bg-carbon-850 p-8 sm:p-12" data-id="element-139" data-mp="h5y8oeopdd3m">
          <QuoteIcon className="h-8 w-8 text-volt" aria-hidden="true" data-id="element-140" data-mp="m51dby0rthb2" />

          <div className="relative mt-6 min-h-[180px] sm:min-h-[150px]" data-id="element-141" data-mp="m6cj23ds0z4t">
            <AnimatePresence mode="wait" data-id="element-142" data-mp="7928cw8yjxa5">
              <motion.blockquote key={index} initial={{
              opacity: 0,
              y: 12
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -12
            }} transition={{
              duration: 0.3,
              ease: 'easeOut'
            }} data-id="element-143" data-mp="7a4zn5a701ql">
                <p className="text-lg leading-relaxed text-slate-200 sm:text-xl" data-id="element-144" data-mp="14ura2qo3gd5m">
                  “{active.quote}”
                </p>
                <footer className="mt-6 flex items-center gap-3" data-id="element-145" data-mp="v5g1r6917cis">
                  <img src={active.avatar} alt="" className="h-11 w-11 rounded-full border border-carbon-600 object-cover" data-id="element-146" data-mp="v3mqterdy64z" />
                  <div data-id="element-147" data-mp="1no3e9x9ypj89">
                    <p className="text-sm font-bold text-white" data-id="element-148" data-mp="1xhquzg0vzcps">{active.name}</p>
                    <p className="text-xs text-slate-400" data-id="element-149" data-mp="1xfmu76yaattq">{active.role}</p>
                  </div>
                </footer>
              </motion.blockquote>
            </AnimatePresence>
          </div>

          <div className="mt-8 flex items-center justify-between border-t border-carbon-700 pt-6" data-id="element-150" data-mp="1oj5j23px6vxz">
            <div className="flex gap-2" role="tablist" aria-label="Seleccionar testimonio" data-id="element-151" data-mp="1jkkjm6ihsgal">
              {testimonials.map((item, i) => <button key={item.name} type="button" role="tab" aria-selected={i === index} aria-label={`Testimonio de ${item.name}`} onClick={() => setIndex(i)} className={`h-1.5 rounded-full transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-volt ${i === index ? 'w-8 bg-safety' : 'w-3 bg-carbon-600 hover:bg-carbon-500'}`} data-id="element-152" data-mp="19rdemmrnz2b1" data-mpi={i} />)}
            </div>

            <div className="flex gap-2" data-id="element-153" data-mp="37fh72mgyta4k">
              <button type="button" onClick={() => go(-1)} aria-label="Testimonio anterior" className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-carbon-600 text-slate-300 transition-colors hover:border-volt hover:text-volt focus:outline-none focus-visible:ring-2 focus-visible:ring-volt" data-id="element-154" data-mp="37efkplui117j">
                <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-155" data-mp="2oq0wt7fha3ay" />
              </button>
              <button type="button" onClick={() => go(1)} aria-label="Testimonio siguiente" className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-carbon-600 text-slate-300 transition-colors hover:border-volt hover:text-volt focus:outline-none focus-visible:ring-2 focus-visible:ring-volt" data-id="element-156" data-mp="2spjgy0zh6acq">
                <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-157" data-mp="1lxewlseuwz7u" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}